import { Checkbox, Input, Menu } from "semantic-ui-react";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRefinementList } from "react-instantsearch";

import Flex from "../../../../components/Flex/Flex";

export default function InstantSearchRefinementList({
	attribute,
	searchable,
	transformItems,
	renderItem,
	groupItems,
	limit = 5,
	showMore = true,
	showMoreLimit = 1000,
}) {
	const { t } = useTranslation();

	const [query, setQuery] = useState("");
	const [itemsToRender, setItemsToRender] = useState([]);

	const { refine, items, canRefine, searchForItems, canToggleShowMore, toggleShowMore, isShowingMore, isFromSearch } =
		useRefinementList({
			attribute,
			searchable,
			transformItems,
			limit,
			showMore,
			showMoreLimit,
		});

	useEffect(() => {
		if (searchable) {
			searchForItems(query);
		}
	}, [query, searchForItems, searchable]);

	useEffect(() => {
		const groupedItems = groupItems?.map(({ label, values }) => {
			const filteredItems = items.filter((item) => values.includes(item.value));

			const value = values.join(",");

			const count = filteredItems.reduce((acc, item) => acc + item.count, 0);
			const isRefined = filteredItems.some((item) => item.isRefined);

			return { value, label, count, isRefined };
		});

		const itemsToRender = groupedItems || items;

		if (query && isFromSearch) {
			setItemsToRender(itemsToRender);
		}

		if (!query && !isFromSearch) {
			setItemsToRender(itemsToRender);
		}
	}, [groupItems, isFromSearch, items, query]);

	return (
		<>
			{searchable && (
				<Menu.Item>
					<Input
						fluid
						transparent
						icon="search"
						iconPosition="left"
						placeholder={t("search", "Search") + "..."}
						onChange={(e, { value }) => setQuery(value)}
					/>
				</Menu.Item>
			)}

			{itemsToRender.map((item) => (
				<Menu.Item key={item.value} disabled={!canRefine} onClick={() => item.value.split(",").forEach(refine)}>
					<Flex>
						<Checkbox checked={item.isRefined} label={renderItem?.(item) || item.label} />

						{item.count}
					</Flex>
				</Menu.Item>
			))}

			{!query && canToggleShowMore && (
				<Menu.Item onClick={() => toggleShowMore()}>
					{isShowingMore ? t("showLess", "Show less") : t("showMore", "Show more")}
				</Menu.Item>
			)}
		</>
	);
}
